"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.injectScreenWidth = injectScreenWidth;
exports.screenWidths = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _context, _context2;
var styles = {
  "mobilePortrait": "screen_width_provider-module__mobilePortrait___yX9cP",
  "mobileLandscape": "screen_width_provider-module__mobileLandscape___RgD5E",
  "tabletPortrait": "screen_width_provider-module__tabletPortrait___RS0UC",
  "tabletLandscape": "screen_width_provider-module__tabletLandscape___rIkNV",
  "desktop": "screen_width_provider-module__desktop___lEUgr",
  "desktopLarge": "screen_width_provider-module__desktopLarge___Db9SP",
  "desktopExtraLarge": "screen_width_provider-module__desktopExtraLarge___oCNul"
}; // must be in descending order
const screenWidths = ['desktopExtraLarge', 'desktopLarge', 'desktop', 'tabletLandscape', 'tabletPortrait', 'mobileLandscape', 'mobilePortrait'];
exports.screenWidths = screenWidths;
const ScreenWidth = /*#__PURE__*/_react.default.createContext('');
ScreenWidth.displayName = 'ScreenWidthProvider';
class DetectionElements extends _react.default.PureComponent {
  renderDetectionElements() {
    return (0, _map.default)(screenWidths).call(screenWidths, width => /*#__PURE__*/_react.default.createElement("div", {
      key: width,
      ref: this.props.setDetectionRef,
      "data-width": width,
      className: styles[width]
    }));
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, this.renderDetectionElements());
  }
}
class ScreenWidthProvider extends _react.default.PureComponent {
  state = {
    width: ''
  };
  detectionRefs = {};
  isVisible(width) {
    if ((0, _keys.default)(this.detectionRefs).length !== screenWidths.length) {
      // does not have all detection ref elements yet
      return false;
    }
    const ref = this.detectionRefs[width];
    return ref && window.getComputedStyle(ref).display !== 'none';
  }
  updateScreenWidthDebounced = (0, _bind.default)(_context = (0, _lodash.default)(this.updateScreenWidth, 200)).call(_context, this);
  updateScreenWidth() {
    for (let width of screenWidths) {
      if (this.isVisible(width) && this.state.width !== width) {
        this.setState({
          width
        });
        return;
      }
    }
  }
  componentDidMount() {
    this.updateScreenWidth();
    window.addEventListener('resize', this.updateScreenWidthDebounced);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateScreenWidthDebounced);
  }
  setDetectionRef = (0, _bind.default)(_context2 = this.setDetectionRef).call(_context2, this);
  setDetectionRef(ref) {
    if (ref) {
      this.detectionRefs[ref.getAttribute('data-width')] = ref;
    }
  }
  render() {
    const {
      children
    } = this.props;
    const {
      width
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DetectionElements, {
      setDetectionRef: this.setDetectionRef
    }), /*#__PURE__*/_react.default.createElement(ScreenWidth.Provider, {
      value: width
    }, children));
  }
}
exports.default = ScreenWidthProvider;
function injectScreenWidth(Component) {
  return props => /*#__PURE__*/_react.default.createElement(ScreenWidth.Consumer, null, screenWidth => /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
    screenWidth: screenWidth
  })));
}